import { Box, LinearProgress } from "@mui/material";
import React from "react";

export default function ScreenLoader() {
  return (
    <div>
      <LinearProgress />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3>Authenticating User.....</h3>
      </Box>
      ;
    </div>
  );
}
